// extracted by mini-css-extract-plugin
module.exports = {"col":"_3f7lzCLVPLLoQI-hHDbu2Z","iconText":"_3BXzKeFknBLzEoSC5Ca-bg","container":"_1VtJ5xdjiDHKEjRfywImBu"};